import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

import theme from '../../../theme';
import { postRecrutierAgencyUpdate } from '../../../views/usersList/usersListReducer';
import { DropdownSearchBar } from '../../DropdownSearchBar/DropdownSearchBar';

const styles = theme?.components?.userCard;

const RecruiterAgencySelectionModal = ({ userAgency, open, onClose, userName, userId }) => {
  const [selectedAgency, setSelectedAgency] = useState(userAgency ?? null);

  const dispatch = useDispatch();
  const onRecruiterAgencyChangeSubmit = () => {
    const changeRecruiterAgencyPayload = {
      agencyId: selectedAgency._id,
      recruiterId: userId,
    };
    dispatch(postRecrutierAgencyUpdate(changeRecruiterAgencyPayload));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={styles.agencyHeaderStyle}>
          {LanguageConverterV2('userCard.recruiter.agency.header', { userName })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DropdownSearchBar
          onSubmitApiCallData={{
            httpMethod: 'POST',
            route: 'agency/read',
          }}
          optionDisplayField="name"
          placeholder={LanguageConverter('userCard.agency.placeholder')}
          sx={{}}
          value={selectedAgency}
          fullWidth
          onChange={(event, newValue) => {
            setSelectedAgency(newValue);
          }}
        />
        <Box sx={styles.agencyButtonContainer}>
          <Button variant="outlined" onClick={onClose} sx={styles.backButton}>
            {LanguageConverter('buttonText.goBack')}
          </Button>
          <Button
            variant="contained"
            sx={styles.agencyChangeButton}
            onClick={onRecruiterAgencyChangeSubmit}
          >
            {LanguageConverter('buttonText.changeAgency')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

RecruiterAgencySelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  userAgency: PropTypes.shape({}),
  onClose: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default RecruiterAgencySelectionModal;
